/**
 * McMaster-Carr style "replace content at each level" sidebar navigation.
 *
 * Phase 1 - Category drilling (levels 0-2):
 *   Sidebar shows sibling categories as clickable links.
 *   Click one → sidebar replaces content with that category's children.
 *   Breadcrumbs handle navigation back up.
 *
 * Phase 2 - Parametric filtering (leaf level):
 *   When you reach a leaf node (no children), sidebar hides the category
 *   list and shows Shopify's native collection.filters panel (#mcFilters).
 *
 * Uses pushState so the browser back/forward buttons work.
 */
(function () {
  'use strict';

  /* ── DOM refs ─────────────────────────────────────────────── */
  var listEl    = document.getElementById('mcList');
  var crumbsEl  = document.getElementById('mcCrumbs');
  var titleEl   = document.getElementById('mcTitle');
  var filtersEl = document.getElementById('mcFilters');

  if (!listEl) return; // sidebar not on this page

  /* ── State ────────────────────────────────────────────────── */
  var tree          = null;   // loaded from category-tree.json
  var rootChildren  = [];     // top-level handles
  var currentHandle = null;   // handle currently being viewed
  var serverRootIntact = true; // true until JS first wipes #mcList

  /* ── Reverse-lookup: collection_handle → category handle ── */
  var collectionToHandle = {};

  /* ── Icon map (matches keywords in title to SVG) ────────── */
  var iconMap = [
    { keys: ['lumber','wood'],        svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="3" width="22" height="5" rx="1"/><rect x="1" y="10" width="22" height="5" rx="1"/><rect x="1" y="17" width="22" height="4" rx="1"/></svg>' },
    { keys: ['cabinet'],              svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="4" width="20" height="16" rx="1"/><line x1="12" y1="4" x2="12" y2="20"/><line x1="8" y1="10" x2="10" y2="10"/><line x1="14" y1="10" x2="16" y2="10"/></svg>' },
    { keys: ['door','window'],        svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="2" width="18" height="20" rx="1"/><line x1="12" y1="2" x2="12" y2="22"/><line x1="3" y1="12" x2="21" y2="12"/></svg>' },
    { keys: ['roof','gutter'],        svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 21h18"/><path d="M5 21V10l7-7 7 7v11"/></svg>' },
    { keys: ['siding','exterior'],    svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="1"/><line x1="3" y1="8" x2="21" y2="8"/><line x1="3" y1="13" x2="21" y2="13"/><line x1="3" y1="18" x2="21" y2="18"/></svg>' },
    { keys: ['deck','outdoor','fenc'],svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 22h20"/><rect x="4" y="12" width="16" height="3" rx="0.5"/><line x1="6" y1="15" x2="6" y2="22"/><line x1="18" y1="15" x2="18" y2="22"/></svg>' },
    { keys: ['concrete','masonry'],   svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="8" height="8"/><rect x="13" y="3" width="8" height="8"/><rect x="3" y="13" width="8" height="8"/><rect x="13" y="13" width="8" height="8"/></svg>' },
    { keys: ['insulation','weather'], svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 3h18v18H3z"/><path d="M7 7h10v10H7z"/><path d="M11 11h2v2h-2z"/></svg>' },
    { keys: ['drywall','interior wall'],svg:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="1"/><line x1="3" y1="12" x2="21" y2="12"/></svg>' },
    { keys: ['moulding','molding','millwork','trim'],svg:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 3h18"/><path d="M3 8h18"/><path d="M6 3v5"/><path d="M12 3v5"/><path d="M18 3v5"/></svg>' },
    { keys: ['electric'],             svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>' },
    { keys: ['plumb','pipe'],         svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 3v6"/><path d="M18 3v6"/><path d="M6 9a6 6 0 0 0 12 0"/><path d="M12 15v6"/></svg>' },
    { keys: ['paint','stain'],        svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M19 3H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"/><path d="M12 11v5"/><path d="M10 22a2 2 0 0 1-2-2v-4h8v4a2 2 0 0 1-2 2h-4z"/></svg>' },
    { keys: ['fastener','screw','nail','anchor','hardware'],svg:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>' },
    { keys: ['tool'],                 svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>' },
    { keys: ['floor','tile'],         svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>' },
    { keys: ['safety','ppe'],         svg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' }
  ];
  var defaultIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>';

  function iconFor(title) {
    var t = title.toLowerCase();
    for (var i = 0; i < iconMap.length; i++) {
      for (var k = 0; k < iconMap[i].keys.length; k++) {
        if (t.indexOf(iconMap[i].keys[k]) !== -1) return iconMap[i].svg;
      }
    }
    return defaultIcon;
  }

  /**
   * Populate icon SVGs into the server-rendered root list without rebuilding it.
   * The Liquid markup emits empty <span class="mc-sidebar__icon" data-icon-for="Title">
   * slots; this fills them based on title keyword match.
   * Also rewrites clickable links that have drill-down children into drill triggers.
   */
  function applyIconsToServerRoot() {
    if (!listEl) return;
    var iconSpans = listEl.querySelectorAll('[data-icon-for]');
    for (var i = 0; i < iconSpans.length; i++) {
      var span = iconSpans[i];
      if (span.childNodes.length > 0) continue; // already filled
      var title = span.getAttribute('data-icon-for') || '';
      span.innerHTML = iconFor(title);
    }

    // If we have the tree loaded, promote links whose handle has children
    // into drill-down triggers (so clicking drills instead of navigating).
    if (tree) {
      var items = listEl.querySelectorAll('.mc-sidebar__item[data-handle]');
      for (var j = 0; j < items.length; j++) {
        var li = items[j];
        var linkHandle = li.getAttribute('data-handle');
        // The linklist handle won't always match the category-tree key, but
        // when it does and that node has children, wire it as a drill.
        var node = linkHandle && tree[linkHandle];
        if (node && node.children && node.children.length > 0) {
          var a = li.querySelector('a.mc-sidebar__link');
          if (a && !a.hasAttribute('data-drill')) {
            a.setAttribute('data-drill', linkHandle);
            a.setAttribute('href', '#');
          }
        }
        // Mark active if the current path matches this link's url
        var aEl = li.querySelector('a.mc-sidebar__link');
        var hrefUrl = aEl && aEl.getAttribute('data-url');
        if (hrefUrl && window.location.pathname === hrefUrl) {
          li.classList.add('mc-sidebar__item--active');
        }
      }
    }
  }

  /* ── Helpers ──────────────────────────────────────────────── */

  /** Build the breadcrumb path from a handle up to root */
  function getAncestors(handle) {
    var path = [];
    var h = handle;
    while (h && tree[h] && tree[h].parent) {
      h = tree[h].parent;
      path.unshift(h);
    }
    return path;
  }

  /** Detect which category we're in based on current URL collection handle */
  function detectFromUrl() {
    var path = window.location.pathname;
    var m = path.match(/\/collections\/([^\/\?#]+)/);
    if (m) {
      var collHandle = m[1];
      if (collectionToHandle[collHandle]) {
        return collectionToHandle[collHandle];
      }
    }
    // Check for a sidebar state param
    var params = new URLSearchParams(window.location.search);
    var sb = params.get('sb');
    if (sb && tree[sb]) return sb;
    return null;
  }

  /* ── Render ───────────────────────────────────────────────── */

  function render(handle, pushHistory) {
    if (!tree) return;

    var node = handle ? tree[handle] : tree['_root'];
    if (!node) { handle = null; node = tree['_root']; }

    currentHandle = handle;

    var isLeaf = node.children.length === 0;
    var isRoot = !handle || handle === '_root';

    /* ── Breadcrumbs ── */
    if (isRoot) {
      crumbsEl.style.display = 'none';
      crumbsEl.innerHTML = '';
    } else {
      crumbsEl.style.display = 'block';
      var crumbHtml = '<a class="mc-crumb" href="#" data-handle="_root">All Categories</a>';
      var ancestors = getAncestors(handle);
      for (var a = 0; a < ancestors.length; a++) {
        crumbHtml += ' <span class="mc-crumb-sep">/</span> ';
        crumbHtml += '<a class="mc-crumb" href="#" data-handle="' + ancestors[a] + '">' + tree[ancestors[a]].title + '</a>';
      }
      // Current level (not clickable)
      crumbHtml += ' <span class="mc-crumb-sep">/</span> ';
      crumbHtml += '<span class="mc-crumb mc-crumb--current">' + node.title + '</span>';
      crumbsEl.innerHTML = crumbHtml;
    }

    /* ── Title ── */
    if (isRoot) {
      titleEl.innerHTML = 'Categories';
    } else {
      titleEl.innerHTML = iconFor(node.title) + ' ' + node.title;
    }

    /* ── Category list vs Filters ── */
    if (isLeaf) {
      // Phase 2: show filters, hide list
      listEl.style.display = 'none';
      if (filtersEl) filtersEl.style.display = 'block';

      // If leaf has a collection, maybe navigate to it
      if (node.collection && pushHistory) {
        var collUrl = '/collections/' + node.collection;
        if (window.location.pathname !== collUrl) {
          window.location.href = collUrl;
          return;
        }
      }
    } else {
      // Phase 1: show category list, hide filters
      listEl.style.display = 'block';
      if (filtersEl) filtersEl.style.display = 'none';

      // If we're on root AND the server-rendered markup is still untouched,
      // trust the server-rendered DOM; just apply icons to it. No layout shift,
      // no wipe-and-replace on first paint.
      if (isRoot && serverRootIntact) {
        applyIconsToServerRoot();
        return;
      }

      // Fade transition
      listEl.classList.add('mc-fade');
      setTimeout(function () { listEl.classList.remove('mc-fade'); }, 10);

      var items = node.children;
      var html = '';

      // If not root and the category itself has a collection, show a "View all" link
      if (!isRoot && node.collection) {
        html += '<li class="mc-sidebar__item mc-sidebar__item--viewall">';
        html += '<a class="mc-sidebar__link mc-sidebar__link--viewall" href="/collections/' + node.collection + '">';
        html += 'View All ' + node.title;
        html += ' <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4.5 2.5l3.5 3.5-3.5 3.5"/></svg>';
        html += '</a></li>';
      }

      for (var i = 0; i < items.length; i++) {
        var child = tree[items[i]];
        if (!child) continue;

        var hasKids = child.children.length > 0;
        var childCollection = child.collection;
        var isCurrentCollection = false;

        // Check if this child matches the current page collection
        var curPath = window.location.pathname;
        if (childCollection && curPath === '/collections/' + childCollection) {
          isCurrentCollection = true;
        }

        html += '<li class="mc-sidebar__item' + (isCurrentCollection ? ' mc-sidebar__item--active' : '') + '">';

        if (hasKids) {
          // Has subcategories: drill down
          html += '<a class="mc-sidebar__link" href="#" data-drill="' + items[i] + '">';
          if (isRoot) html += '<span class="mc-sidebar__icon">' + iconFor(child.title) + '</span>';
          html += '<span class="mc-sidebar__link-text">' + child.title + '</span>';
          html += '<svg class="mc-sidebar__arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4.5 2.5l3.5 3.5-3.5 3.5"/></svg>';
          html += '</a>';
        } else if (childCollection) {
          // Leaf with collection: link to collection page
          html += '<a class="mc-sidebar__link" href="/collections/' + childCollection + '">';
          if (isRoot) html += '<span class="mc-sidebar__icon">' + iconFor(child.title) + '</span>';
          html += '<span class="mc-sidebar__link-text">' + child.title + '</span>';
          html += '</a>';
        } else {
          // Leaf without collection: drill down (will show filters or placeholder)
          html += '<a class="mc-sidebar__link" href="#" data-drill="' + items[i] + '">';
          if (isRoot) html += '<span class="mc-sidebar__icon">' + iconFor(child.title) + '</span>';
          html += '<span class="mc-sidebar__link-text">' + child.title + '</span>';
          html += '</a>';
        }

        html += '</li>';
      }

      listEl.innerHTML = html;
      // We just wiped the server-rendered root; any subsequent render to root
      // must also do a full re-render rather than trusting the DOM.
      serverRootIntact = false;
    }

    /* ── History ── */
    if (pushHistory) {
      var stateUrl = window.location.pathname;
      var params = new URLSearchParams(window.location.search);
      if (handle && handle !== '_root') {
        params.set('sb', handle);
      } else {
        params.delete('sb');
      }
      var qs = params.toString();
      var newUrl = stateUrl + (qs ? '?' + qs : '');
      history.pushState({ mcHandle: handle }, '', newUrl);
    }
  }

  /* ── Event delegation ─────────────────────────────────────── */

  listEl.addEventListener('click', function (e) {
    var link = e.target.closest('[data-drill]');
    if (link) {
      e.preventDefault();
      render(link.getAttribute('data-drill'), true);
    }
  });

  crumbsEl.addEventListener('click', function (e) {
    var crumb = e.target.closest('[data-handle]');
    if (crumb) {
      e.preventDefault();
      var h = crumb.getAttribute('data-handle');
      render(h === '_root' ? null : h, true);
    }
  });

  /* ── Browser back/forward ─────────────────────────────────── */
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.mcHandle !== undefined) {
      render(e.state.mcHandle, false);
    } else {
      render(detectFromUrl(), false);
    }
  });

  /* ── Init ─────────────────────────────────────────────────── */

  function init() {
    // Fetch the tree JSON from theme assets
    var jsonUrl = document.querySelector('[data-mc-tree-url]');
    var url = jsonUrl ? jsonUrl.getAttribute('data-mc-tree-url') : null;

    // Fallback: try to construct Shopify asset URL
    if (!url) {
      // In Shopify themes, asset_url generates a CDN path. We pass it via a data attribute.
      // If that fails, try a relative path (won't work on Shopify but good for dev).
      url = '/assets/category-tree.json';
    }

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        tree = data;

        // Build collection → handle reverse map
        for (var handle in tree) {
          if (tree[handle].collection) {
            collectionToHandle[tree[handle].collection] = handle;
          }
          // Track root children
          if (tree[handle].parent === null && handle !== '_root') {
            rootChildren.push(handle);
          }
        }

        // Determine starting state
        var detected = detectFromUrl();

        if (detected) {
          var node = tree[detected];
          if (node && node.children.length === 0) {
            // We're on a leaf collection page. Render the parent crumbs, then
            // switch to filters (Phase 2). Hide the category list so we never
            // show a category list AND a filter list at the same time.
            if (node.parent) {
              render(node.parent, false);
              if (filtersEl && filtersEl.children.length > 0) {
                if (listEl) listEl.style.display = 'none';
                filtersEl.style.display = 'block';
              }
            } else {
              render(null, false);
            }
          } else if (node && node.children.length > 0) {
            // We're on a parent collection - drill into it
            render(detected, false);
          } else {
            render(null, false);
          }
        } else {
          render(null, false);
        }

        // Replace initial history state
        history.replaceState({ mcHandle: currentHandle }, '');
      })
      .catch(function (err) {
        console.warn('[McMaster Sidebar] Failed to load category tree:', err);
        // Leave the Liquid-rendered root visible, but still paint icons.
        applyIconsToServerRoot();
      });
  }

  // Start when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
